if (libraries.knockoutValidation) {
  ko.validation.rules.notEmpty = {
    hasItems: function(data) {
      var result, value;
      value = ko.unwrap(data);
      result = false;
      if (value.length && value.length > 0) {
        result = true;
      }
      return result;
    },
    validator: function(value) {
      return this.hasItems(value);
    },
    message: 'Must not be empty'
  };
}
